export default __webpack_public_path__ + "static/media/Laughing black lady.ac3b2987.jpg";